import React, {useEffect} from 'react'
import Select from 'react-select'
import { Button } from 'reactstrap'
import getRoleList from '../../../../service/getRoles';
import { labelizeNamedData } from '@/shared/helpers'
import getUserStatusList from '@/service/getUserStatuses';
import { getPositionLevels } from '@/service/program/position';


const FilterForm = ({onClickFilterCallback, filter, organization, program}) => {
    const [keyword, setKeyword] = React.useState('')
    const [role, setUserRole]   = React.useState('')
    const [selectedRole, setSelectedRoleName]   = React.useState('')
    const [roleOptions, setRoleOptions] = React.useState([])
    const [statusOptions, setStatusOptions] = React.useState([])
    const [status, setStatus] = React.useState('')
    const [positionLevel, setPositionLevel] = React.useState('')
    const [selectedPositionLevel, setSelectedPositionLevel] = React.useState('')
    const [positionLevelOptions, setPositionLevelOptions] = React.useState([])

     useEffect(() => {
        getRoleList(organization.id)
            .then(list => {
                setRoleOptions(
                    [
                        ...[{'value': '', label: 'All'}],
                        ...labelizeNamedData(list.data)
                    ]
                )
            })
    }, [organization]);

    useEffect(() => {
        if (organization?.id) {
            getUserStatusList(organization.id)
                .then(list => {
                    setStatusOptions(
                        [
                            ...[{ 'value': '', label: 'All' }],
                            ...labelizeNamedData(list, ["status", "status"])
                        ]
                    )
                })
        }
    }, [organization])

    useEffect(() => {
        if (organization?.id && program?.id) {
            getPositionLevels(organization.id, program.id)
                .then(list => {
                    setPositionLevelOptions(
                        [
                            ...[{ 'value': '', label: 'All' }],
                            ...labelizeNamedData(list, ["id", "title"])
                        ]
                    )
                })
        }
    }, [organization, program])

    const rolePlaceholder = role ? role : 'All'
    const onKeywordChange = ( e ) => {
        setKeyword( e.target.value );
    }

    const onRoleChange = ( e ) => {
        setSelectedRoleName(e);
        setUserRole( e.value );
    }

     const onStatusChange = (selectedOption) => {
        setStatus(selectedOption.value)
    };

    const onPositionLevelChange = (e) => {
        setSelectedPositionLevel(e);
        setPositionLevel(e.value);
    };

    const onClickFilter = (e) => {
        e.preventDefault();
        onClickFilterCallback({keyword:keyword, role_id: role, status: status, position_level: positionLevel});
    }

    useEffect(() => {
        setKeyword( filter?.keyword );
        setUserRole( filter?.role_id );
        setStatus( filter?.status );
        setPositionLevel( filter?.position_level );
    }, [filter]);

    const resetFilter  =(e) => {
        onClickFilterCallback({keyword:'', role_id: '', status: '', position_level: ''});
    }

    const statusPlaceholder = status ? status : 'All'
    const positionLevelPlaceholder = positionLevel ? positionLevel : 'All'

    return (
        <form className="form__form-group" onSubmit={onClickFilter}>
            <div className="col-md-3">
                <p className="">Search Users</p>
                <div className="">
                    <input
                        value={keyword}
                        onChange={onKeywordChange}
                        type="text"
                        name='keywords'
                        placeholder="Search by ID, email, name, Employee ID."
                    />
                </div>
            </div>
            <div className="col-md-2 pr-0">
                <p className="">Role</p>
                <div>
                    <Select
                        value={selectedRole}
                        onChange={onRoleChange}
                        options={roleOptions}
                        className="react-select"
                        placeholder={rolePlaceholder}
                        classNamePrefix="react-select"
                    />
                </div>
            </div>
            <div className="col-md-2 pr-0">
                <p className="">Status</p>
                <div>
                    <Select
                        value={status}
                        onChange={onStatusChange}
                        options={statusOptions}
                        clearable={false}
                        className="react-select"
                        placeholder={statusPlaceholder}
                        classNamePrefix="react-select"
                    />
                </div>
            </div>
            <div className="col-md-2 pr-0">
                <p className="">Position</p>
                <div>
                    <Select
                        value={selectedPositionLevel}
                        onChange={onPositionLevelChange}
                        options={positionLevelOptions}
                        className="react-select"
                        placeholder={positionLevelPlaceholder}
                        classNamePrefix="react-select"
                    />
                </div>
            </div>
            <div className="col-md-3 d-flex align-items-center pl-1 justify-content-end">
          
            <div className="">
                <p className="">&nbsp;</p>
                <Button  
                    type='submit'
                    className="btn btn-sm btn-primary mb-0" 
                    color="#ffffff"
                >
                    Filter
                </Button>
            </div>

            <div className="pl-1">
                <p className="">&nbsp;</p>
                <Button  
                    type='reset'
                    className="btn btn-sm btn-secondary mb-0" 
                    color="#ffffff"
                    onClick={resetFilter}
                >
                    Reset
                </Button>
            </div>
            </div>
        </form>
    )
}

export default FilterForm;